module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class=\'mbx-info\'>\n    <p>' +
((__t = ( i18next.t('ui.rebuild_confirmation', {name}) )) == null ? '' : __t) +
'</p>\n    <p>\n    <i class="' +
((__t = ( WiseMetering.icons.info )) == null ? '' : __t) +
' modal-description-warning" style="margin-right: 10px; font-size: 1em;" aria-hidden=\'true\'></i>\n        ' +
((__t = ( i18next.t('ui.rebuild_description') )) == null ? '' : __t) +
'\n</div>\n';

}
return __p
}